@if ({ isTop: isTopNav$ | async }; as navigation) {
    <div [ngClass]="{ open: !isCollapsed }" class="navbar-top">
        <div class="container--nav">
            <div class="navbar-top__inner container">
                <a [core-analytics]="{ action: 'Home', category: 'TOP-NAV' }" class="navbar-brand" routerLink="/">
                    <span class="navbar-logo-wrapper">
                        <img
                            [alt]="getSiteName() + ' logo'"
                            [src]="'./assets/img/site-logo.svg'"
                            class="navbar-logo"
                            fill
                            priority />
                    </span>
                </a>
                <!-- Top Nav Buttons -->
                <div class="navbar-buttons">
                    @if (!this.auth?.isAuthenticated()) {
                        <button
                            type="button"
                            class="btn btn-contact"
                            (click)="scrollToContactForm()"
                            [core-analytics]="{ action: 'Contact Scroll', category: 'TOP-NAV' }">
                            <span class="btn-icon">
                                <svg xmlns="http://www.w3.org/2000/svg" width="32" height="22" viewBox="0 0 32 22">
                                    <g
                                        id="Blank-Templates"
                                        fill="none"
                                        fill-rule="evenodd"
                                        stroke="none"
                                        stroke-width="1">
                                        <g id="HD-Desktop-(Large)" fill="#FFF" transform="translate(-1111 -5000)">
                                            <g id="Join-Us" transform="translate(150 4731)">
                                                <g id="EMAIL" transform="translate(590 222)">
                                                    <g id="Email_Icon" transform="translate(371 46.168)">
                                                        <path
                                                            fill="#03597A"
                                                            id="Fill-4"
                                                            d="M3.23 20.889c-.237 0-.46-.06-.662-.154l8.575-8.2a.664.664 0 00.05-.902.625.625 0 00-.915-.056l-8.542 8.166a1.549 1.549 0 01-.063-.412V3.79c0-.247.064-.476.165-.684l13.68 8.666a.634.634 0 00.425.163l.007-.001h.007c.157 0 .308-.057.375-.124l13.725-8.708c.104.208.168.439.168.688v15.54c0 .164-.032.32-.08.468l-8.6-8.223a.594.594 0 00-.467-.17.626.626 0 00-.445.225.667.667 0 00.05.905l8.6 8.224c-.19.082-.397.129-.615.129H3.23zM28.669 2.234c.119 0 .233.015.345.04L15.955 10.56 2.88 2.277c.114-.027.23-.043.35-.043h25.438zm0-1.351H3.23A2.908 2.908 0 00.324 3.79v15.54a2.908 2.908 0 002.907 2.908h25.437a2.908 2.908 0 002.907-2.908V3.79A2.908 2.908 0 0028.668.883z" />
                                                    </g>
                                                </g>
                                            </g>
                                        </g>
                                    </g>
                                </svg>
                            </span>
                            CONTACT
                        </button>
                    }
                    @if (this.auth?.isAuthenticated()) {
                        <button
                            class="btn btn-member-login"
                            (click)="this.auth.logout()"
                            [core-analytics]="{ action: 'Member Logout', category: 'TOP-NAV' }">
                            LOGOUT
                        </button>
                    }
                    @if (!this.auth?.isAuthenticated()) {
                        <a
                            class="btn btn-member-login"
                            routerLink="/login"
                            [core-analytics]="{ action: 'Member Login', category: 'TOP-NAV' }">
                            MEMBER LOGIN
                        </a>
                    }
                </div>
            </div>
        </div>
    </div>
}
